module.exports = __webpack_public_path__ + "img/pijltje-drop-down.a46dff9a29b701cb784c6045ed96dcee.svg";